import { render, staticRenderFns } from "./CardIeaCategory.vue?vue&type=template&id=65bbf92c"
import script from "./CardIeaCategory.vue?vue&type=script&lang=js"
export * from "./CardIeaCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports